/**
 * Created by JMC on 16/10/19.
 */

export class IssueTag {
  issue_tag_id: number;
  issue_tag_name: string;
  issue_tag_type_id: number;
}
